import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import { Timestamp } from 'components/datatable'

const MyLatestViewedWidget = ({widget}) => {
  const mounted = useRef(false);
  
  const [entries, setEntries] = useState([]);
  const [title, setTitle] = useState('');

  useEffect(() => {
    mounted.current = true;
    fetch(`coordinatordashboard/${widget.widgetId}`)
    .then((response) => response.json())
    .then((data) => {
      if (mounted.current) {
        setEntries(data.data.entries);
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      mounted.current = false;
    };
  }, [])

  const onClick = (entry) => {
    reactHistory.push({
      order: `/orders/${entry.entry_id}/overview`,
      customer: `/customers/${entry.entry_id}/contact-info`,
      supplier: `/suppliers/${entry.entry_id}/overview`
    }[entry.entry_type])
  };
  
  const widget_id = `ID_${widget.widgetId}`;
  return (
    <li className="bg-white border m-4 shadow rounded border-gray-400" key={widget_id} id={widget_id}>
      <WidgetHeader widget={widget} widgetTitle={title} />

      <div class="w-full text-xs" >
        {entries.map((entry) => 
          <div
              class="hover:bg-gray-200 flex border-b cursor-pointer group"
              title={entry.entry_type}
              onClick={() => onClick(entry)}
          >
              <div class="shrink-0 px-4 py-2 capitalize w-20">
                  {entry.entry_type}
              </div>
              <div class="grow truncate px-4 py-2 group-hover:text-primary">
                  {entry.entry_name}
              </div>
              <div class="shrink-0 text-right px-4 py-2">
                <Timestamp className="truncate">{entry.viewed_at}</Timestamp>
              </div>
          </div>
        )}
      </div>
    </li>
  );

}

export default MyLatestViewedWidget;
